export interface ICommand { }

export class GenerateAccessTokenCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.AccessTokens.Commands.GenerateAccessTokenCommandV1, TCh.Domain.Organizations'

	Id: string
	OrganizationUnitId: string
	GeneratedBy: string
	Secret: string

	constructor (id: string, organizationUnitId: string, generatedBy: string, secret: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.GeneratedBy = generatedBy
		this.Secret = secret
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.AccessTokens.Commands.GenerateAccessTokenCommandV1, TCh.Domain.Organizations'
	}

}

export class RevokeAccessTokenCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.AccessTokens.Commands.RevokeAccessTokenCommandV1, TCh.Domain.Organizations'

	Id: string
	RevokedBy: string

	constructor (id: string, revokedBy: string)
	{
		this.Id = id
		this.RevokedBy = revokedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.AccessTokens.Commands.RevokeAccessTokenCommandV1, TCh.Domain.Organizations'
	}

}

